<template>
  <div>
    <div class="width-full float-left px-4 pb-4">
      <div class="px-4" style>
        <v-row class="pa-0">
          <v-col cols="7" class="pa-0">
            <div v-if="highExpandable" class="width-full float-left">
              <v-btn icon v-if="sliceFrom != 0" @click="upExpand" class="ml-1">
                <v-icon color="#808F9C">expand_less</v-icon>
              </v-btn>
              <v-btn v-else icon @click="upExpand" class="ml-1">
                <v-icon color="#808F9C">expand_more</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="5" class="pa-0 text-right">
            <v-row class="pt-1 pr-2">
              <v-col cols="4" class="pa-0">
                <span class="text-grey" style="font-size: 12px">act.</span>
              </v-col>
              <v-col cols="4" class="pa-0">
                <span class="text-grey" style="font-size: 12px">forec.</span>
              </v-col>
              <v-col cols="4" class="pa-0">
                <span class="text-grey" style="font-size: 12px">prev.</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>

      <transition-group name="list">
        <CalendarItem
          v-for="(makros,index) in dataCalendar.slice(sliceFrom,sliceTo)"
          :key="makros._id"
          :record="makros"
          :index="index"
        />
      </transition-group>
      <div class="width-full float-left">
        <div v-if="lowExpandable" class="width-full float-left">
          <v-btn icon v-if="sliceTo != dataCalendar.length" @click="downExpand" class="ml-1">
            <v-icon color="#808F9C">expand_more</v-icon>
          </v-btn>
          <v-btn v-else icon @click="downExpand" class="ml-1">
            <v-icon color="#808F9C">expand_less</v-icon>
          </v-btn>
        </div>
        <div v-if="isExpandable" class="float-right mt-2">
          <div
            @click="hideAction"
            v-scroll-to="{el: '#calendar-row',offset: -100}"
            class="more text-right"
          >{{hideText}}</div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
var moment = require("moment-timezone");
//import miniSettings from "./miniSettings";
import CalendarItem from "./miniCalendarItem";
export default {
  name: "miniNews",
  components: { 
  //  miniSettings, 
    CalendarItem 
  },
  props: ["dataCalendar"],
  watch: {
    showMore(newVal) {
      if (newVal) {
        this.sliceFrom = 0;
        this.sliceTo = this.dataCalendar.length;
      } else {
        this.sliceFrom = this.sliceFromDef;
        this.sliceTo = this.sliceToDef;
      }
    }
  },
  data() {
    return {
      hideText: "Show All",
      isExpandable: false,
      highExpandable: false,
      lowExpandable: false,
      highExpanded: false,
      lowExpanded: false,
      sliceFromDef: 0,
      sliceToDef: 0,
      sliceFrom: 0,
      sliceTo: 0,
      sliceFromIndex: 0,
      showCount: 5,
      showMore: false,
      tool: true
    };
  },
  mounted() {
    this.reslice();
    this.sliceTo = this.sliceToDef;
    this.sliceFrom = this.sliceFromDef;
    setInterval(() => {
      this.reslice();
    }, 180000);
  },
  methods: {
    scrollToId() {
      //setTimeout(() => {
      var element = document.getElementById("calendar-row");
      var headerOffset = 90;
      var elementPosition = element.getBoundingClientRect().top;
      var offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });

      //document
      //  .getElementById(this.$route.params.message)
      //  .scrollIntoView({ block: "start", behavior: "smooth" });
      //}, 500);
    },
    hideAction() {
      if (this.isExpandable && this.lowExpanded && this.highExpanded) {
        this.sliceFrom = this.sliceFromDef;
        this.sliceTo = this.sliceToDef;
        this.highExpanded = false;
        this.lowExpanded = true;
        this.hideText = "Show All";
        //this.scrollToId()
      } else {
        this.sliceFrom = 0;
        this.sliceTo = this.dataCalendar.length;
        this.lowExpanded = true;
        this.highExpanded = true;
        this.hideText = "Hide";
      }
    },
    upExpand() {
      if (this.sliceFrom != 0) {
        this.sliceFrom = 0; // expanding up
        this.highExpanded = true;
        if ((this.lowExpandable && this.lowExpanded) || !this.lowExpandable) {
          this.fullExpanded = true;
          this.hideText = "Hide";
        }
      } else {
        this.sliceFrom = this.sliceFromDef; // unexpand up
        this.highExpanded = false;
        this.hideText = "Show All";
      }
    },
    downExpand() {
      if (this.sliceTo != this.dataCalendar.length) {
        this.sliceTo = this.dataCalendar.length; // expanding down
        this.lowExpanded = true;
        if (
          (this.highExpandable && this.highExpanded) ||
          !this.highExpandable
        ) {
          this.hideText = "Hide";
        }
      } else {
        this.sliceTo = this.sliceToDef; // unexpand down
        this.lowExpanded = false;
        this.hideText = "Show All";
      }
    },
    reslice() {
      var firstIndex = null;
      var lastIndex = null;
      this.dataCalendar.forEach((rec, index) => {
        var a = moment();
        var b = moment(rec.dateTime);
        var timeDiff = b.diff(a, "minutes");
        if (!lastIndex && timeDiff < 0) {
          lastIndex = index + 1;
          if (lastIndex > this.dataCalendar.length - 1)
            lastIndex = this.dataCalendar.length - 1;
        }
      });
      firstIndex = lastIndex - 5;
      if (firstIndex < 0) {
        var correction = Math.abs(firstIndex);
        lastIndex = lastIndex + correction;
        if (lastIndex > this.dataCalendar.length - 1)
          lastIndex = this.dataCalendar.length;
        firstIndex = 0;
      }

      this.sliceFromDef = firstIndex;
      this.sliceToDef = lastIndex;
      if (
        this.sliceFromDef == 0 &&
        this.sliceToDef == this.dataCalendar.length
      ) {
        this.isExpandable = false;
      } else {
        this.isExpandable = true;
      }
      if (this.sliceFromDef != 0) this.highExpandable = true;
      if (this.sliceToDef != this.dataCalendar.length)
        this.lowExpandable = true;
    }
  }
};
</script>

<style>
</style>